import { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import styles from './ConnectionModal.module.css'

// Re-collects a provider's oauthOverride credentials (e.g. NetSuite's Integration Record
// Client ID/Secret) to reauthorize an existing connection. These are never persisted on our
// side — Nango only ever sees them for the duration of an auth call — so a customer whose
// token needs refreshing has to resupply them here rather than reauth happening silently,
// same as first connect.
export default function ReauthCredentialsModal({ isOpen, provider, overrideFields, onClose, onSubmit }) {
  const [values, setValues] = useState({})

  useEffect(() => {
    if (isOpen) setValues({})
  }, [isOpen])

  if (!isOpen || !provider) return null

  const complete = overrideFields.every(f => values[f.key]?.trim())

  const handleSubmit = () => {
    const credentials = Object.fromEntries(
      overrideFields.map(f => [`oauth_${f.oauthOverride}_override`, values[f.key]])
    )
    onSubmit(credentials)
  }

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={onClose}>✕</button>
        <div className={styles.pane}>
          <div className={styles.providerHero}>
            <span className={styles.providerIcon}>{provider.icon}</span>
            <div>
              <div className={styles.providerName}>{provider.name}</div>
              <div className={styles.providerCat}>Reauthorize</div>
            </div>
          </div>

          <p className={styles.fieldHint}>
            {provider.name} doesn&apos;t let Structuradata store your OAuth app credentials, so
            they&apos;re needed again to reconnect — same as when you first connected.
          </p>

          {overrideFields.map((f, i) => (
            <div key={f.key}>
              <label className={styles.fieldLabel}>{f.label}</label>
              <input
                className={`${styles.fieldInput} ${i > 0 ? styles.fieldInputTop : ''}`}
                type={f.secret ? 'password' : 'text'}
                placeholder={f.placeholder}
                value={values[f.key] || ''}
                onChange={e => setValues(v => ({ ...v, [f.key]: e.target.value }))}
                autoFocus={i === 0}
              />
              {f.hint && <p className={styles.fieldHint}>{f.hint}</p>}
            </div>
          ))}

          <div className={styles.stepActions}>
            <button className={styles.backBtn} onClick={onClose}>Cancel</button>
            <button className={styles.nextBtn} onClick={handleSubmit} disabled={!complete}>
              Reauthorize →
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}
